import axios from 'axios'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import Markdown from 'markdown-to-jsx'
import { GetStaticProps } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { Converters } from 'services/Converters'

type Props = {
  page: any
}

export default function PromotionalBannerPage(props: Props) {
  const attr = props.page.data.attributes
  return (
    <Fragment>
      <Head>
        <title>Promotional Banner</title>
      </Head>
      <div id="promotional-banner">
        <h2 id="huge-vpn-discounts-with-sme-purchase" dangerouslySetInnerHTML={{ __html: attr.title ?? '' }}></h2>
        <p>
          {attr.subtitle}
          <a href={attr.button.link} target="_blank" rel="noreferrer">
            {attr.button.text}
          </a>
        </p>
        <div className="promo-banner-fix">
          <Markdown>{attr.richText}</Markdown>
        </div>
      </div>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const page = await axios({
    method: HTTPMethod.GET,
    baseURL: Env.ApiUrl,
    url: '/promotional-banner',
    params: { populate: 'deep' },
  }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

  return { props: { page }, revalidate: Env.PropsRevalidateTime }
}
